export const bgAnimated = Array.from({ length: 113 }, (_, i) => {
  return {
    url: require(`../Assets/bgAnimated/bg${i + 1}.svg`),
    name: `Bg${i + 1}`,
  }
})
